'use client';

import { Button, TextArea, TextField } from '@paction-2.0/ui';
import { useState } from 'react';

import styles from './feedbackPage.module.scss';

export function FeedbackForm() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [feedback, setFeedback] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setErrorMessage('');
    setIsLoading(true);

    try {
      const response = await fetch('/api/v1.0/public/forms/feedback', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: name.trim(),
          email: email.trim(),
          phone: phone.trim(),
          feedback: feedback.trim()
        })
      });

      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.message || 'Failed to submit feedback');
      }

      setIsSubmitted(true);
    } catch (err) {
      setErrorMessage(
        err instanceof Error ? err.message : 'An unexpected error occurred'
      );
    } finally {
      setIsLoading(false);
    }
  };

  if (isSubmitted) {
    return (
      <div className={styles.form}>
        <div className={styles.successContainer}>
          <div className={styles.successMessage}>
            <p>Your feedback has been submitted.</p>
            <p>
              Thank you for taking the time to submit your thoughts, suggestions
              and concerns. We really appreciate it! If you have provided your
              contact information, we may be in touch to discuss more.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.form}>
      <h2 className={styles.formTitle}>
        Do you have feedback for Paction? Share anything.
      </h2>
      <form onSubmit={handleSubmit}>
        <div className={styles.formInputs}>
          <div className={styles.formRow}>
            <TextField
              label="Name (optional)"
              placeholder="Enter your name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <TextField
              label="Email (optional)"
              placeholder="Enter your email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
              label="Phone (optional)"
              placeholder="Enter your phone number"
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>
          <div className={styles.formRow}>
            <TextArea
              label="Anything to share?"
              placeholder="Share or ask us anything"
              rows={5}
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
            />
          </div>

          {errorMessage && (
            <div className={styles.errorMessage}>{errorMessage}</div>
          )}

          <div className={styles.formActions}>
            <Button type="submit" disabled={isLoading || !feedback.trim()}>
              {isLoading ? 'Submitting...' : 'Submit'}
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
}
